<template>
<div class="backoffice-invoices">
    <div class="page-header">
            <div class="left">
                <h2 class="page-title">{{ $page.props.lang.title || "Invoices List" }}</h2>
            </div>
            <div class="right">
                <!-- <v-btn color="primary" dark @click="expensesModal = true">
                    <v-icon small>mdi-plus</v-icon>
                <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2">{{ $page.props.lang.newExpense || "New expense" }}</span>
                </v-btn> -->
            </div>
        </div>
    <div class="table-container">
        <v-data-table
           :headers="tableHeaders"
           :items="invoices.data"
           :server-items-length="invoices.total"
           :items-per-page="invoices.per_page"
            mobile-breakpoint="0"
            hide-default-footer>
            <template v-slot:item.unique_number="{ item }">
                     {{ item.unique_number}}
            </template>
            <template v-slot:item.issued_date="{ item }">
                     {{ item.issued_date | formatDate }}
            </template>
            <template v-slot:item.member="{ item }">
                     <v-avatar size="25">
                            <img :src="item.member.profile_photo_url + '?w=80'" alt="">
                        </v-avatar>
                        {{ item.member.full_name }}
            </template>
            <template v-slot:item.total_price="{ item }">
                     {{ item.total_price }} <span class="table-currency">{{ $page.props.organization.settings.currency }}</span>
            </template>
            <template v-slot:item.action="{ item }">
                     <v-btn @click="downloadPdf(item)" :id="'download' + item.id" icon>
                        <v-icon color="#AD0B00">mdi-pdf-box</v-icon>
                        <v-tooltip :activator="'#download'+ item.id" bottom open-delay="500">
                            <span>{{$page.props.lang.table_download || "Download PDF"}}</span>
                        </v-tooltip>
                    </v-btn>
            </template>
        </v-data-table>
         <pagination :links="invoices.links" />
    </div>
</div>

</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import Pagination from '@/js/Components/Pagination'
import ConfirmModal from '@/js/Components/ConfirmModal'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import EventBus from '@/js/eventbus'

export default {
    metaInfo() {
        return {
            title:  this.$page.props.lang.title || "List of Invoices"
        }
    },
    layout: AppLayout,
    components: {
        Pagination,
        ConfirmModal
    },
    props: {
        invoices: Object,
        filters: Object,
        lang: Object,
        locale: String
    },
    data(){
        return {
            invoicesData: this.invoices.data,
            tableHeaders: [
                {text: this.lang.table_invoice_number || 'Invoice number', value: 'unique_number', sortable: false, align: 'start'},
                {text: this.lang.table_issued_date || 'Issued date', value: 'issued_date', sortable: false},
                {text: this.lang.table_charged_member || 'Charged member', value: 'member', sortable: false, align: 'left'},
                {text: this.lang.table_total_price || 'Total price', value: 'total_price', sortable: false, align: 'center'},
                {text: this.lang.table_download || 'Download PDF', value: 'action', sortable: false, align: 'end'}
            ],
            invoicePDF: {}
        }
    },
    methods: {
        downloadPdf(item){
            window.location.href = '/backoffice/members/generatePdfInvoice/'+item.id+'/'+item.member.id;
            
        }
    }
}

</script>
